// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/vue2Dropzone.css
// module id = y6jO
// module chunks = 1